/**
 * EventBloom — in-cart upsell "+ Add" button.
 *
 * Loaded from layout/theme.liquid with `defer`, NOT inline in the snippet.
 * The cart drawer and /cart summary are refreshed with morph (see morph.js),
 * and browsers never execute scripts introduced that way — an inline script in
 * snippets/cart-upsell.liquid was therefore dead whenever the card arrived via
 * a cart update, which is the normal path from a product page.
 *
 * The listener is delegated on `document`, so it survives every morph and works
 * for cards that appear long after page load.
 */
(function () {
  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cart-upsell-add]') : null;
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id || id === 'REPLACE_WITH_VARIANT_ID') return;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        // Same event the theme uses; each cart-items-component re-renders its
        // section (drawer + /cart) via the Section Rendering API — no reload.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'cart-upsell', data: { source: 'cart-upsell' } }
        }));
      })
      .catch(function () { btn.disabled = false; });
  });
})();
